// removed by extract-text-webpack-plugin
module.exports = {"root":"v3XO21lbF2KTJmfBkP6aN"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true,"publicPath":"/"}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"id":"data-v-b82ba146","scoped":false,"hasInlineConfig":false}!./~/gotu-vue-dycolor/dist/lib/dycolor-loader.js!./~/sass-loader/lib/loader.js?{"sourceMap":true}!./src/components/lab/creative-external-previews/CreativeExternalPreviews.scss
// module id = 1011
// module chunks = 1